module.exports = __webpack_public_path__ + "img/BlackWidow_01.cf33f6a3.png";